import { render, staticRenderFns } from "./ProductContentChapters.vue?vue&type=template&id=44091d60&scoped=true&"
import script from "./ProductContentChapters.vue?vue&type=script&lang=js&"
export * from "./ProductContentChapters.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentChapters.vue?vue&type=style&index=0&id=44091d60&prod&scoped=true&lang=css&"
import style1 from "./ProductContentChapters.vue?vue&type=style&index=1&id=44091d60&prod&lang=css&"
import style2 from "./ProductContentChapters.vue?vue&type=style&index=2&id=44091d60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44091d60",
  null
  
)

export default component.exports